export interface ReportBannerImageProps {
  src: string;
  alt: string;
  caption?: string | null;
}

/**
 * Report banner: always fills the page width with the whole image, scaled up or down, so the
 * banner is as tall as the image's shape needs.
 */
export const ReportBannerImage = ({
  src,
  alt,
  caption,
}: ReportBannerImageProps) => {
  if (src === "") {
    return null;
  }

  return (
    <figure className="m-0 w-full">
      <img src={src} alt={alt} className="block h-auto w-full" />
      {caption != null && caption !== "" ? (
        <figcaption className="mt-1 px-4 text-xs text-muted-foreground">
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
};
